<template>
    <b-modal :title="$t('core.confirm')" :ref="_uid" @ok="confirm">
        {{ $t('core.areYouSure') }}
        <template v-slot:modal-footer="{ ok, cancel }">
            <b-button @click="cancel()">
                Cancel
            </b-button>
            <b-button @click="ok()" name="restoreOnly" variant="primary">
                {{ $t('history.buttons.restore') }}
            </b-button>
            <b-button v-if="showRestoreAndBookInsurance" @click="confirmWithInsurance" name="restoreWithInsurance" variant="primary">
                {{ $t('history.buttons.restoreWithInsurance')}}
            </b-button>
        </template>
    </b-modal>
</template>
<script>
export default {
    props:{
        showRestoreAndBookInsurance: {type: Boolean, default: false}
    },
    methods: {
        show() {
            this.$refs[this._uid].show();
        },
        confirm() {
            this.$emit('confirmAction', false);
        },
        confirmWithInsurance(){
            this.$emit('confirmAction', true)
        }
    }
};
</script>

<style></style>
